import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useState } from "react";

export default function ContactoPage() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      await fetch("https://readdy.ai/api/form/d79n92j86jhav3jpfnj0", { method: "POST", body: data });
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="relative h-64 flex items-center justify-center overflow-hidden">
        <img src="https://public.readdy.ai/ai/img_res/90040d8221c7aff4d4152dd272dbd7ec.jpg" alt="Contacto GERPAT" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center px-4">
          <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Estamos aquí</span>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mt-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>CONTACTO</h1>
        </div>
      </section>

      <section className="py-20 bg-[#f8f7f5]">
        <div className="max-w-6xl mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Info */}
          <div>
            <h2 className="text-2xl font-extrabold text-[#1a1a1a] mb-6" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>INFORMACIÓN DE CONTACTO</h2>
            <div className="space-y-5 mb-8">
              {[
                { icon: "ri-map-pin-line", title: "Dirección", value: "Partida San Juan S/N\nCastillonroy 22572, Huesca" },
                { icon: "ri-phone-line", title: "Teléfono", value: "+34 638 25 09 36" },
                { icon: "ri-whatsapp-line", title: "WhatsApp", value: "+34 638 25 09 36" },
                { icon: "ri-mail-line", title: "Email", value: "facturaciongerpat@gmail.com" },
                { icon: "ri-time-line", title: "Disponibilidad", value: "Consulte horarios de servicio" },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-[#FF6B35] text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-xs text-gray-400 font-semibold uppercase tracking-wide">{item.title}</div>
                    <div className="text-sm text-[#1a1a1a] font-medium whitespace-pre-line">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="w-full h-52 rounded-xl overflow-hidden">
              <iframe title="Mapa GERPAT" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2975.0!2d0.6!3d41.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sCastillonroy%2C+Huesca!5e0!3m2!1ses!2ses!4v1" width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy"></iframe>
            </div>
          </div>

          {/* Form */}
          <div className="bg-white rounded-2xl p-8">
            <h2 className="text-2xl font-extrabold text-[#1a1a1a] mb-6" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>ENVÍENOS UN MENSAJE</h2>
            {submitted ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-green-600 text-3xl"></i>
                </div>
                <h3 className="text-lg font-bold text-[#1a1a1a] mb-2">¡Mensaje enviado!</h3>
                <p className="text-gray-500 text-sm">Nos pondremos en contacto con usted lo antes posible.</p>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide block mb-1">Nombre *</label>
                    <input name="nombre" required className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#FF6B35]" placeholder="Su nombre" />
                  </div>
                  <div>
                    <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide block mb-1">Teléfono *</label>
                    <input name="telefono" required className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#FF6B35]" placeholder="+34 000 000 000" />
                  </div>
                </div>
                <div>
                  <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide block mb-1">Email *</label>
                  <input name="email" type="email" required className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#FF6B35]" placeholder="su@email.com" />
                </div>
                <div>
                  <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide block mb-1">Servicio</label>
                  <select name="servicio" className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#FF6B35] cursor-pointer">
                    <option value="">Seleccionar servicio...</option>
                    <option>Grúa para turismo</option>
                    <option>Grúa para vehículo pesado</option>
                    <option>Asistencia en carretera</option>
                    <option>Transporte de maquinaria</option>
                    <option>Compra-venta de vehículos</option>
                    <option>Otro</option>
                  </select>
                </div>
                <div>
                  <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide block mb-1">Mensaje *</label>
                  <textarea name="mensaje" required maxLength={500} rows={4} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#FF6B35] resize-none" placeholder="Describa su consulta..."></textarea>
                </div>
                <button type="submit" disabled={loading} className="w-full bg-[#FF6B35] hover:bg-[#e55a25] disabled:opacity-60 text-white font-bold py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer">
                  {loading ? "Enviando..." : "Enviar mensaje"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
